<template>
    <el-dialog :title="'编辑名称'" :visible="isShow" :width="width + 'px'" center @close="closeDialog">
        <slot name="container"></slot>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="confirm">确认</el-button>
            <el-button size="small" plain @click="closeDialog">取消</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: {
        isShow: {
            type: Boolean,
            default: true
        },
        width: {
            type: Number,
            default: 520
        }
    },
    data () {
        return {

        }
    },
    methods: {
        confirm () {
            this.$emit('confirm')
        },
        closeDialog () {
            this.$emit('closeDialog')
        }
    }

}
</script>

<style lang="scss" scoped>
.dialog-footer {
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/Dialog.vue